module.exports = __webpack_public_path__ + "img/zuo@3x.11a55e19.png";